import FallbackComponent from '@components/std-components/FallbackComponent'
import React, { FC, lazy, Suspense } from 'react'
import { GradingPopupProps } from './GradingPopup'

const GradingPopupLazy = lazy(() => import('./GradingPopup'))

const GradingPopupContent: FC<GradingPopupProps> = props => {
  return (
    <Suspense fallback={<FallbackComponent />}>
      <GradingPopupLazy {...props} />
    </Suspense>
  )
}

export default GradingPopupContent
